import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaUltimoSimulacro from "./Equipos/CreaModals/CreaUltimoSimulacro";
import Cookies from "universal-cookie";

function Titulo231SeccionC(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerSimulacros = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerUltimoSimulacroPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((res) => setList(res.data || []))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    obtenerSimulacros();
  }, [props.idSolicitud]);

  const eliminarSimulacro = (id) => {
    if (!window.confirm("¿Desea eliminar este simulacro?")) return;

    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarUltimoSimulacroPorId?Id=${id}`,
      data: {
        tipoAccion: "Eliminación de último simulacro",
        idUsuario: cookies.get("id"),
      },
    })
      .then(() => {
        alert("Simulacro eliminado");
        obtenerSimulacros();
      })
      .catch(() => alert("Error al eliminar simulacro"));
  };
  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Simulacros realizados en el último año
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
          nombreRuta === "ProcesoAutoevaluacion" ? (
            <CreaUltimoSimulacro
              idSolicitud={props.idSolicitud}
              onCreate={obtenerSimulacros}
            />
          ) : null}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Fecha</th>
                  <th>Recomendaciones</th>
                  <th>Seguimiento</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.fechaSimulacro}</td>
                      <td>{item.recomendaciones}</td>
                      <td>{item.seguimientoRecomendaciones}</td>
                      <td>
                        {nombreRuta === "ProcesoAutoevaluacion" && (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarSimulacro(item.id)}
                          >
                            Eliminar
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo231SeccionC;
